/**
 * This file contains prop => style functions related to UI direction.
 */
import { Theme } from "./theme"
import { stringLiteralArray } from "./utils"

export type Direction = typeof directions[number]

const directions = stringLiteralArray(["ltr", "rtl"])
const direction = ({ theme }: { theme: Theme }) => theme.direction

const side = ({ theme }: { theme: Theme }) =>
  theme.direction === "ltr" ? "left" : "right"

export { direction, directions, side }
